import type { THierarchicalComment } from "./typings";
import { useAuthorAvatar } from "./hooks";
import { CommentIcon } from "_c/Icon";
import cls from "./styles.module.css";
import type { TRespondTarget } from "../CommentForm/typings";
import { isEmpty } from "@/utils/is-empty";
import FormattedDate from "@/components/FormattedDate";

type TProps = {
  comment: THierarchicalComment;
  changeRespondTarget: (target: TRespondTarget) => any;
};
const Comment = ({ comment, changeRespondTarget }: TProps) => {
  const avatar = useAuthorAvatar(comment);
  const onRespondClick = () => {
    changeRespondTarget({
      commentId: comment.id,
      authorName: comment.author?.name ?? "",
      avatar,
    });
    (document.querySelector("#comment-form_message") as HTMLElement).focus();
  };
  return (
    <li className={cls.comment}>
      <div
        style={{
          padding: "7px",
          paddingLeft: 0,
        }}
      >
        <div
          style={{
            display: "flex",
          }}
        >
          <img className={cls.avatar} src={avatar} alt="Аватар" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "10px",
            }}
          >
            <span
              style={{
                fontWeight: 900,
              }}
            >
              {comment.author?.name}
            </span>
            <FormattedDate isSSR date={comment.date} />
          </div>
        </div>
        <p>{comment.content}</p>
        <button
          type="button"
          className={cls.respondBtn}
          onClick={onRespondClick}
        >
          <CommentIcon />
          <span>Ответить</span>
        </button>
      </div>
      {!isEmpty(comment.children) && (
        <ul>
          {comment.children!.map((comment) => (
            <Comment
              changeRespondTarget={changeRespondTarget}
              comment={comment}
              key={comment.id}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default Comment;
